module.exports = __webpack_public_path__ + "img/req_call_bg.ae9f8375.png";